import decode from 'jwt-decode';
import moment from 'moment'
export default class AppointmentService {
    // Initializing important variables
    constructor(domain) {
    }
    getUrl(){
      var loc = window.location;
      var url = new URL(loc)
      var enviorment_url = url.hostname
      if(enviorment_url == "booking-staging.getspiffy.com"){
        return "https://staging.getspiffy.com/api/v1/"
      }
      else if(enviorment_url == "booking.getspiffy.com"){
        return "https://my.getspiffy.com/api/v1/"
      }
      else {
        return "http://localhost:3000/api/v1/"
      }
    }
    appointments() {
      var prefix = this.getUrl()
      var url = prefix + "appointments.json"
      return fetch(url, {
        method: "GET",
        //mode: 'no-cors',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'X-Auth-Token': localStorage.getItem('id_token')
        }

      })
      .then((response) => response.json())
      .then(response => {
        return response;
      })
      .catch((error) => {
        //alert('Unable to login, please double check email and password are entered correctly.');
        });
    }
    giftcard_images() {
      var prefix = this.getUrl()
      var url = prefix + "giftcard_images.json"
      return fetch(url, {
        method: "GET",
        //mode: 'no-cors',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'X-Auth-Token': localStorage.getItem('id_token')
        }

      })
      .then((response) => response.json())
      .then(response => {
        return response;
      })
      .catch((error) => {
        //alert('Unable to login, please double check email and password are entered correctly.');
        });
    }
    getActivity(page) {
      var prefix = this.getUrl()
      var url = prefix + "appointment_list.json?page=" + page
        return fetch(url, {
          method: "GET",
          //mode: 'no-cors',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'X-Auth-Token': localStorage.getItem('id_token')
          }

        })
        .then((response) => response.json())
        .then(response => {
          return response;
        })
        .catch((error) => {
          //alert('Unable to login, please double check email and password are entered correctly.');
          });
    }
    getUser() {
      var prefix = this.getUrl()
      var url = prefix + "user.json"
      return fetch(url, {
        method: "GET",
        //mode: 'no-cors',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'X-Auth-Token': localStorage.getItem('id_token')
        }

      })
      .then((response) => response.json())
      .then(response => {
        return response;
      })
      .catch((error) => {
        //alert('Unable to login, please double check email and password are entered correctly.');
        });
    }
    updateUser(first_name, last_name, email, phone_number, password, partnerCode){
      var prefix = this.getUrl()
      var url = prefix + "update_user.json"
      var data = {}
      if(password){
        data = {
          user: {
            first_name: first_name,
            last_name: last_name,
            email: email,
            phone: phone_number,
            partner_code: partnerCode,
            password: password
          }
        }
      }
      else {
        data = {
          user: {
            first_name: first_name,
            last_name: last_name,
            email: email,
            phone: phone_number,
            partner_code: partnerCode,
          }
        }
      }
      return fetch(url, {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'X-Auth-Token': localStorage.getItem('id_token')
        }

      })
      .then((response) => response.json())
      .then(response => {
        return response;
      })
      .catch((error) => {
        //alert('Unable to login, please double check email and password are entered correctly.');
        });
    }
    getAds() {
      var prefix = this.getUrl()
      var url = prefix + "ads.json"
      return fetch(url, {
        method: "GET",
        //mode: 'no-cors',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'X-Auth-Token': localStorage.getItem('id_token'),
        }
      })
      .then((response) => response.json())
      .then(response => {
        return response;
      })
      .catch((error) => {
        console.err("Ad blocker is probably blocking this")
        //alert('Unable to login, please double check email and password are entered correctly.');
        });
    }
    messages() {
      var prefix = this.getUrl()
      var url = prefix + "messages.json"
      return fetch(url, {
        method: "GET",
        //mode: 'no-cors',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'X-Auth-Token': localStorage.getItem('id_token')
        }

      })
      .then((response) => response.json())
      .then(response => {
        return response;
      })
      .catch((error) => {
        });
    }
    serviceMenu() {
      var prefix = this.getUrl()
      var url = prefix + "full_menu.json"
      return fetch(url, {
        method: "GET",
        //mode: 'no-cors',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'X-Auth-Token': localStorage.getItem('id_token')
        }

      })
      .then((response) => response.json())
      .then(response => {
        return response;
      })
      .catch((error) => {
        });
    }
    holidays() {
      var prefix = this.getUrl()
      var url = prefix + "holidays.json"
      return fetch(url, {
        method: "GET",
        //mode: 'no-cors',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'X-Auth-Token': localStorage.getItem('id_token')
        }

      })
      .then((response) => response.json())
      .then(response => {
        return response;
      })
      .catch((error) => {
        });
    }
    cle
    clearMessages(messageId) {
      var prefix = this.getUrl()
      var url = prefix + "clear_messages.json"
      var data = {
        message: {
          customer_id: localStorage.getItem('customer_id'),
          upto_message_id: messageId
        }
      }
      return fetch(url, {
        method: "POST",
        //mode: 'no-cors',
        body: JSON.stringify(data),
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'X-Auth-Token': localStorage.getItem('id_token')
        }

      })
      .then((response) => response.json())
      .then(response => {
        return response;
      })
      .catch((error) => {
        //alert('Unable to login, please double check email and password are entered correctly.');
        });
    }

    sendMessage(text) {
      var prefix = this.getUrl()
      var url = prefix + "message.json"
      var data = {
        message: {
          customer_id: localStorage.getItem('customer_id'),
          message: text

        }
      }
      var url = url
      return fetch(url, {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'X-Auth-Token': localStorage.getItem('id_token')
        }

      })
      .then((response) => response.json())
      .then(response => {
        return response;
      })
      .catch((error) => {
        console.log("catch")
        //alert('Unable to login, please double check email and password are entered correctly.');
        });
    }
    appointment(id) {
      var prefix = this.getUrl()
      var url = prefix + "appointment.json?appointment_ids=" + id
      return fetch(url, {
        method: "GET",
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'X-Auth-Token': localStorage.getItem('id_token')
        }

      })
      .then((response) => response.json())
      .then(response => {
        console.log(response)
        return response;
      })
      .catch((error) => {
        //alert('Unable to login, please double check email and password are entered correctly.');
        });
    }
    giftcard_image(id) {
      var prefix = this.getUrl()
      var url = prefix + "giftcard_image.json?image_id=" + id
      return fetch(url, {
        method: "GET",
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'X-Auth-Token': localStorage.getItem('id_token')
        }

      })
      .then((response) => response.json())
      .then(response => {
        console.log(response)
        return response;
      })
      .catch((error) => {
        //alert('Unable to login, please double check email and password are entered correctly.');
        });
    }
    createGiftcard(amount, cardId, name, email, phone,message,sendAt, creditCard){
      var prefix = this.getUrl()
      var date = moment(sendAt).format('L')
      if(!sendAt || (sendAt.getTime() < (new Date().setDate(new Date().getDate() + 1)))){
        date = null
      }
      var url = prefix + "create_giftcard.json"
      var data = {
          giftcard: {
            customer_id: localStorage.getItem('customer_id'),
            amount: amount * 100,
            card_id: creditCard.value
          },
          notification: {
            name: name,
            email: email,
            phone: phone,
            message:message,
            send_at: date
          }
      }
      console.log(data)
      return fetch(url, {
        method: "POST",
        body: JSON.stringify(data),
         headers: {
           'Accept': 'application/json',
           'Content-Type': 'application/json',
           'X-Auth-Token': localStorage.getItem('id_token')
         }

      })
      .then((response) => response.json())
      .then(response => {
        return response;
      })
      .catch((error) => {
        console.log("catch")
        //alert('Unable to login, please double check email and password are entered correctly.');
        });
    }
    processRedeem(code) {
      var prefix = this.getUrl()
      var url = prefix + "redeem_giftcard.json"
      var data = {
        giftcard: {
          customer_id: localStorage.getItem('customer_id'),
          code: code

        }
      }
      return fetch(url, {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'X-Auth-Token': localStorage.getItem('id_token')
        }

      })
      .then((response) => response.json())
      .then(response => {
        return response;
      })
      .catch((error) => {
        console.log("catch")
        //alert('Unable to login, please double check email and password are entered correctly.');
        });
    }
    creditCards() {
      var prefix = this.getUrl()
      var url = prefix + "credit_cards.json"
      return fetch(url, {
        method: "GET",
        //mode: 'no-cors',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'X-Auth-Token': localStorage.getItem('id_token')
        }

      })
      .then((response) => response.json())
      .then(response => {
        return response;
      })
      .catch((error) => {
        //alert('Unable to login, please double check email and password are entered correctly.');
        });
    }
    setDefaultCard(card_id){
      var prefix = this.getUrl()
      var url = prefix + "set_default_credit_card.json"
      var data = {
        card: {
          id: card_id,
        }
      }
      return fetch(url, {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'X-Auth-Token': localStorage.getItem('id_token')
        }

      })
      .then((response) => response.json())
      .then(response => {
        return response;
      })
      .catch((error) => {
        console.log("catching default card")
        //alert('Unable to login, please double check email and password are entered correctly.');
        });
    }
    deleteCard(cardId){
      var prefix = this.getUrl()
      var url = prefix + "delete_credit_card.json"
      var data = {
        card: {
          id: cardId
        }
      }
      return fetch(url, {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'X-Auth-Token': localStorage.getItem('id_token')
        }

      })
      .then((response) => response.json())
      .then(response => {
        return response;
      })
      .catch((error) => {
        console.log("catch")
        //alert('Unable to login, please double check email and password are entered correctly.');
        });
    }
    addCreditCardByStripeID(stripeID){
      var prefix = this.getUrl()
      var url = prefix + "create_credit_card_from_token.json"
      var data = {
        card: {
          card_id: stripeID
        }
      }
      return fetch(url, {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'X-Auth-Token': localStorage.getItem('id_token')
        }

      })
      .then((response) => response.json())
      .then(response => {
        return response;
      })
      .catch((error) => {
        throw new Error("Error adding card by Stripe ID" + error)
        //alert('Unable to login, please double check email and password are entered correctly.');
        });
    }
    addCreditCard(number, expMonth, expYear, cvc, name, billingZipcode){
      var prefix = this.getUrl()
      var url = prefix + "create_credit_card.json"
      var data = {
        card: {
          number: number,
          exp_month: expMonth,
          exp_year: expYear,
          cvc: cvc,
          name: name,
          address_zip: billingZipcode
        }
      }
      return fetch(url, {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'X-Auth-Token': localStorage.getItem('id_token')
        }

      })
      .then((response) => response.json())
      .then(response => {
        return response;
      })
      .catch((error) => {
        console.log("catch")
        //alert('Unable to login, please double check email and password are entered correctly.');
        });
    }
    redeemGiftcard(giftcardCode){
      var prefix = this.getUrl()
      var url = prefix + "redeem_giftcard.json"
      var data = {
        giftcard: {
          code: giftcardCode
        }
      }
      return fetch(url, {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'X-Auth-Token': localStorage.getItem('id_token')
        }

      })
      .then((response) => response.json())
      .then(response => {
        return response;
      })
      .catch((error) => {
        console.log("catch")
        //alert('Unable to login, please double check email and password are entered correctly.');
        });
    }
  check_partner_allowed(){
    var prefix = this.getUrl()
    var url = prefix + "check_partner_codes_accepted.json"
    return fetch(url, {
      method: "GET",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'X-Auth-Token': localStorage.getItem('id_token')
      }

    })
        .then((response) => response.json())
        .then(response => {
          return response;
        })
        .catch((error) => {
          console.log("catch", error)
          //alert('Unable to login, please double check email and password are entered correctly.');
        });
  }
  check_promo(id, promoString){
      var prefix = this.getUrl()
      var url = prefix + "update_appointment.json"
      var data = {
        appointment: {
          id: id,
          promo_code: promoString
        }
      }
      return fetch(url, {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'X-Auth-Token': localStorage.getItem('id_token')
        }

      })
      .then((response) => response.json())
      .then(response => {
        return response;
      })
      .catch((error) => {
        console.log("catch")
        //alert('Unable to login, please double check email and password are entered correctly.');
        });
    }
    get_valid_promo(packages, upgrades, promoString){
      var packageIds = []
      packages.forEach(function(p) {
        packageIds.push(p.id)
      })
      var packageString = packageIds.toString()
      packageString = "packages=" + "%5B" + packageString + "%5D" + "&"

      var upgradeIds = []
      upgrades.forEach(function(av) {
        av.forEach(function(u) {
          upgradeIds.push(u.package_upgrade_id)
        })
      })
      var upgradeString = upgradeIds.toString()
      upgradeString = "package_upgrades=" + "%5B" + upgradeString + "%5D" + "&"

      const promoURLString = "promo_code=" + promoString + "&"
      const customerString = "customer_id=" + localStorage.getItem('customer_id');
      const params = "?" + packageString + upgradeString + promoURLString + customerString
      var prefix = this.getUrl()
      var url = prefix + "get_valid_promo.json" + params
      return fetch(url, {
        method: "GET",
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'X-Auth-Token': localStorage.getItem('id_token')
        }

      })
      .then((response) => response.json())
      .then(response => {
        return response;
      })
      .catch((error) => {
        console.log("catch", error)
        //alert('Unable to login, please double check email and password are entered correctly.');
        });
    }

  check_active_promo(promoString){
      const promoURLString = "promo_code=" + promoString
      const params = "?" + promoURLString
      var prefix = this.getUrl()
      var url = prefix + "check_active_promo.json" + params
      return fetch(url, {
        method: "GET",
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'X-Auth-Token': localStorage.getItem('id_token')
        }

      })
          .then((response) => response.json())
          .then(response => {
            return response;
          })
          .catch((error) => {
            console.log("catch", error)
            //alert('Unable to login, please double check email and password are entered correctly.');
          });
    }

    removePromo(appt_id){
      var prefix = this.getUrl()
      var url = prefix + "remove_promo.json"
      var data = {
        appointment: {
          id: appt_id,
        }
      }
      return fetch(url, {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'X-Auth-Token': localStorage.getItem('id_token')
        }

      })
      .then((response) => response.json())
      .then(response => {
        return response;
      })
      .catch((error) => {
        console.log("catch")
        //alert('Unable to login, please double check email and password are entered correctly.');
        });
    }

    addRating(rating, reviewComments, appointmentVehicleId, appointment_id){
      var prefix = this.getUrl()
      var url = prefix + "update_appointment.json"
      var data = {
        appointment: {
          id: appointment_id,
          appointment_vehicles_attributes: [
               {
                 id: appointmentVehicleId,
                 review_rating: rating,
                 review_comments: reviewComments
               }
             ]
        }
      }
      return fetch(url, {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'X-Auth-Token': localStorage.getItem('id_token')
        }

      })
      .then((response) => response.json())
      .then(response => {
        return response;
      })
      .catch((error) => {
        console.log("catch")
        //alert('Unable to login, please double check email and password are entered correctly.');
        });
    }
    addresses() {
      var prefix = this.getUrl()
      var url = prefix + "addresses.json"


      return fetch(url, {
        method: "GET",
        //mode: 'no-cors',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'X-Auth-Token': localStorage.getItem('id_token')
        }

      })
      .then((response) => response.json())
      .then(response => {
        return response;
      })
      .catch((error) => {
        //alert('Unable to login, please double check email and password are entered correctly.');
        });
      }
      vehicles() {
        var prefix = this.getUrl()
        var url = prefix + "vehicles.json"
        return fetch(url, {
          method: "GET",
          //mode: 'no-cors',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'X-Auth-Token': localStorage.getItem('id_token')
          }

        })
        .then((response) => response.json())
        .then(response => {
          return response;
        })
        .catch((error) => {
          //alert('Unable to login, please double check email and password are entered correctly.');
          });
        }

      rslBuildings(lat, lng){
        var prefix = this.getUrl()
        var url = prefix + "client_host/locations.json?lat=" + lat + "&lng=" + lng
        return fetch(url, {
          method: "GET",
          //mode: 'no-cors',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'X-Auth-Token': localStorage.getItem('id_token')
          }

        })
        .then((response) => response.json())
        .then(response => {
          return response;
        })
        .catch((error) => {
          alert('Unable to retrieve Work Locations')
      })
    }

      addressFromCoords(lat, lng){
        var url = "https://maps.googleapis.com/maps/api/geocode/json?key=AIzaSyD2mSKeIWHZpjASwcopmqGaWmkqqEgcf80&latlng=" + lat + "," + lng
        return fetch(url, {
          method: "GET",
          //mode: 'no-cors',
          // headers: {
          //   'Accept': 'application/json',
          //   'Content-Type': 'application/json',
          //   'X-Auth-Token': localStorage.getItem('id_token')
          // }

        })
        .then((response) => response.json())
        .then(response => {
          return response;
        })
        .catch((error) => {
          alert("Unable to get Address from the map location")
          //alert('Unable to login, please double check email and password are entered correctly.');
          });
      }

      saveNewAddress(street, city, state, zipcode, display_title, street_adtl){
        var prefix = this.getUrl()
        var url = prefix + "create_address.json"
        var data = {
          address: {
          display_title: display_title,
          street: street,
          city: city,
          state_abbr: state,
          postal: zipcode,
          street_adtl: street_adtl
          }
        }
        return fetch(url, {
          method: "POST",
          body: JSON.stringify(data),
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'X-Auth-Token': localStorage.getItem('id_token')
          }

        })
        .then((response) => response.json())
        .then(response => {
          return response;
        })
        .catch((error) => {
          //alert('Unable to login, please double check email and password are entered correctly.');
          });
      }
      updateAddress(id, display_title, street, city, state_abbr, zipcode, street_adtl,  hidden){
        var prefix = this.getUrl()
        var url = prefix + "update_address.json"
        var data = {
          address: {
          id: id,
          display_title: display_title,
          street: street,
          city: city,
          state_abbr: state_abbr,
          postal: zipcode,
          street_adtl: street_adtl,
          hidden: hidden
          }
        }
        return fetch(url, {
          method: "POST",
          body: JSON.stringify(data),
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'X-Auth-Token': localStorage.getItem('id_token')
          }

        })
        .then((response) => response.json())
        .then(response => {
          return response;
        })
        .catch((error) => {
          //alert('Unable to login, please double check email and password are entered correctly.');
          });
      }
      hideAddress(id, hidden = true){
        var prefix = this.getUrl()
        var url = prefix + "hide_address.json"
        var data = {
          address: {
            id: id,
            hidden: hidden
          }
        }
        return fetch(url, {
          method: "POST",
          body: JSON.stringify(data),
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'X-Auth-Token': localStorage.getItem('id_token')
          }

        })
            .then((response) => response.json())
            .then(response => {
              return response;
            })
            .catch((error) => {
              //alert('Unable to login, please double check email and password are entered correctly.');
            });
      }
      createAppointment(addressId, startAt, packageIds, vehicleIds, upgradeIds, promoCode){
        var prefix = this.getUrl()
        var url = prefix + "create_appointment.json"
        var appt_vehicles = []
        var start = startAt.format()
        var i = 0
        var partnerCodeUsed = packageIds.some(el => el.bookedWithPartnerCode === true);
        vehicleIds.forEach(function(v) {
          var appt_vehicle = {
            package_id: packageIds[i].id,
            vehicle_id: v.id,
            upgrade_ids: upgradeIds[i]
          }
          i++
          appt_vehicles.push(appt_vehicle)
        })
        var data = {
          appointment: {
            address_id: addressId,
            start_at: start,
            promo_code:promoCode,
            origin: 'Consumer-Web 2.0.4',
            appointment_vehicles_attributes: appt_vehicles,
            via_partner_code: partnerCodeUsed

          }
        }
        console.log(data)
        return fetch(url, {
          method: "POST",
          body: JSON.stringify(data),
           headers: {
             'X-Auth-Token': localStorage.getItem('id_token')
           }

        })
        .then((response) => response.json())
        .then(response => {
          return response;
        })
        .catch((error) => {
          //alert('Unable to login, please double check email and password are entered correctly.');
          });
      }
      confirmAppt(id){
        var prefix = this.getUrl()
        var url = prefix + "progress_appointment.json"
        var data = {
          appointment: {
            aasm_state: 'confirmed',
            id: id
          }
        }
        console.log(data)
        return fetch(url, {
          method: "POST",
          body: JSON.stringify(data),
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'X-Auth-Token': localStorage.getItem('id_token')
          }

        })
        .then((response) => response.json())
        .then(response => {
          return response;
        })
        .catch((error) => {
          //alert('Unable to login, please double check email and password are entered correctly.');
          });
      }

      rslBuildings(lat, lng){
        var prefix = this.getUrl()
        var url = prefix + "client_host/locations.json?lat=" + lat + "&lng=" + lng
        return fetch(url, {
          method: "GET",
          //mode: 'no-cors',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'X-Auth-Token': localStorage.getItem('id_token')
          }

        })
        .then((response) => {
          return response.json();
        })
        .then(response => {
          return response;
        })
        .catch((error) => {
          alert('Unable to retrieve Work Locations')
          //alert('Unable to login, please double check email and password are entered correctly.');
          });
      }
      charge(appointmentId, tipAmount, cardId, useAccountBalance){
        var prefix = this.getUrl()
        var url = prefix + "charge.json"
        var data = {
          charge: {
            tip_amount: appointmentId,
            appointment_id: tipAmount,
            card_id: cardId,
            use_account_balance: useAccountBalance
          }
        }
        return fetch(url, {
          method: "POST",
          body: JSON.stringify(data),
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'X-Auth-Token': localStorage.getItem('id_token')
          }

        })
        .then((response) => response.json())
        .then(response => {
          return response;
        })
        .catch((error) => {
          console.log("catch")
          //alert('Unable to login, please double check email and password are entered correctly.');
          });
      }

      get_vehicle_years(){
        var prefix = this.getUrl()
        var url = prefix + "vehicle_years.json"
        return fetch(url, {
          method: "GET",
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'X-Auth-Token': localStorage.getItem('id_token')
          }
          //mode: 'no-cors',
          // headers: {
          //   'Accept': 'application/json',
          //   'Content-Type': 'application/json',
          //   'X-Auth-Token': localStorage.getItem('id_token')
          // }

        })
        .then((response) => response.json())
        .then(response => {
          return response;
        })
        .catch((error) => {
          console.log("catch")
          //alert('Unable to login, please double check email and password are entered correctly.');
          });
      }

      get_vehicle_makes(year){
        var prefix = this.getUrl()
        var url = prefix + "vehicle_makes.json?year=" + year
        return fetch(url, {
          method: "GET",
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'X-Auth-Token': localStorage.getItem('id_token')
          }
          //mode: 'no-cors',
          // headers: {
          //   'Accept': 'application/json',
          //   'Content-Type': 'application/json',
          //   'X-Auth-Token': localStorage.getItem('id_token')
          // }

        })
        .then((response) => response.json())
        .then(response => {
          return response;
        })
        .catch((error) => {
          console.log("ERROR INM SERVICE")
          return []
          //alert('Unable to login, please double check email and password are entered correctly.');
          });
      }
      // get_vehicle_ids(searchTerm){
      //   var prefix = this.getUrl()
      //   var url = prefix + "vehicle_ids.json?search_term=" + searchTerm
      //   return fetch(url, {
      //     method: "GET",
      //     headers: {
      //       'Accept': 'application/json',
      //       'Content-Type': 'application/json',
      //       'X-Auth-Token': localStorage.getItem('id_token')
      //     }
      //     //mode: 'no-cors',
      //     // headers: {
      //     //   'Accept': 'application/json',
      //     //   'Content-Type': 'application/json',
      //     //   'X-Auth-Token': localStorage.getItem('id_token')
      //     // }
      //
      //   })
      //   .then((response) => response.json())
      //   .then(response => {
      //     return response;
      //   })
      //   .catch((error) => {
      //     return []
      //     //alert('Unable to login, please double check email and password are entered correctly.');
      //     });
      // }
      get_vehicle_models(make, year){
        var prefix = this.getUrl()
        var url = prefix + "vehicle_models.json?make=" + make + '&year=' +  year
        return fetch(url, {
          method: "GET",
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'X-Auth-Token': localStorage.getItem('id_token')
          }
          //mode: 'no-cors',
          // headers: {
          //   'Accept': 'application/json',
          //   'Content-Type': 'application/json',
          //   'X-Auth-Token': localStorage.getItem('id_token')
          // }

        })
        .then((response) => response.json())
        .then(response => {
          return response;
        })
        .catch((error) => {
          return []
          //alert('Unable to login, please double check email and password are entered correctly.');
          });
      }
      get_vehicle_type(year, make, model){
        var prefix = this.getUrl()
        var url = prefix + "vehicle_type.json?make=" + make + '&year=' +  year + '&model=' + model
        return fetch(url, {
          method: "GET",
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'X-Auth-Token': localStorage.getItem('id_token')
          }
        })
        .then((response) => response.json())
        .then(response => {
          return response;
        })
        .catch((error) => {
          return []
          //alert('Unable to login, please double check email and password are entered correctly.');
          });
      }
      updateVehicle(year, make, model, color, vtype, id, hidden){
        var prefix = this.getUrl()
        var url = prefix + "update_vehicle.json"
        var data = {
          vehicle: {
          vehicle_type_id: vtype,
          year: year,
          make: make,
          model: model,
          color: color,
          id: id,
          hidden: hidden
          }
        }
        return fetch(url, {
          method: "POST",
          body: JSON.stringify(data),
           headers: {
             'X-Auth-Token': localStorage.getItem('id_token')
           }

        })
        .then((response) => response.json())
        .then(response => {
          return response;
        })
        .catch((error) => {
          console.log("catch")
          //alert('Unable to login, please double check email and password are entered correctly.');
          });
      }
      updateMileage(id, mileage){
        var prefix = this.getUrl()
        var url = prefix + "update_mileage.json"
        var data = {
          vehicle: {
            id: id,
            mileage: mileage,
            force_save: "true"
          }
        }
        return fetch(url, {
          method: "POST",
          body: JSON.stringify(data),
           headers: {
             'X-Auth-Token': localStorage.getItem('id_token')
           }

        })
        .then((response) => response.json())
        .then(response => {
          return response;
        })
        .catch((error) => {
          console.log("catch")
          //alert('Unable to login, please double check email and password are entered correctly.');
          });
      }
      saveVehicle(year, make, model, color, vtype){
        var prefix = this.getUrl()
        var url = prefix + "create_vehicle.json"
        var data = {
          vehicle: {
          vehicle_type_id: vtype,
          year: year,
          make: make,
          model: model,
          color: color,
          }
        }
        return fetch(url, {
          method: "POST",
          body: JSON.stringify(data),
           headers: {
             'X-Auth-Token': localStorage.getItem('id_token')
           }

        })
        .then((response) => response.json())
        .then(response => {
          return response;
        })
        .catch((error) => {
          console.log("catch")
          //alert('Unable to login, please double check email and password are entered correctly.');
          });
      }
      packages(zipcode, vehicle_type_id, vehicle_id, address_id, partner_code = null){
        var prefix = this.getUrl()
        var url = prefix + "packages.json?zipcode=" + zipcode + "&vehicle_type_id=" + vehicle_type_id + "&vehicle_id=" + vehicle_id + "&address_id=" + address_id + "&use_partner_code=" + true

        if(partner_code !== null)
        {
          url +=  "&partner_code=" + partner_code
        }

        return fetch(url, {
          method: "GET",
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'X-Auth-Token': localStorage.getItem('id_token')
          }
          //mode: 'no-cors',
          // headers: {
          //   'Accept': 'application/json',
          //   'Content-Type': 'application/json',
          //   'X-Auth-Token': localStorage.getItem('id_token')
          // }

        })
        .then((response) => response.json())
        .then(response => {
          return response;
        })
        .catch((error) => {
          console.log("catch")
          //alert('Unable to login, please double check email and password are entered correctly.');
          });
      }

      get_tax_amount(packages, upgrades, addressId, promo_amount){
        var prefix = this.getUrl()
        var url = prefix + "get_tax_amount.json"
        var data = {}
          data = {
            appointment: {
              package_ids: packages,
              upgrade_ids: upgrades,
              address_id: addressId,
              promo_amount: promo_amount
            }
        }
        return fetch(url, {
          method: "POST",
          body: JSON.stringify(data),
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'X-Auth-Token': localStorage.getItem('id_token')
          }

        })
        .then((response) => response.json())
        .then(response => {
          return response;
        })
        .catch((error) => {
          //alert('Unable to login, please double check email and password are entered correctly.');
          });
      }
}



// WEBPACK FOOTER //
// ./src/utils/AppointmentService.js